// DEPRECATED: superseded by InboundTriggerNodeInfo (inboundEventType='call').
// Kept so existing published InboundCallTrigger workflows continue to render.
// Remove after all InboundCallWorkflow rows are migrated to InboundTriggerWorkflow.
import type { LBNodeData } from '@/proto/logiblocks/logiblocks';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { InboundCallTriggerCustomization } from './InboundCallTriggerCustomization';
import { buildNodeData } from '../../nodeDataUtils';
import { PhoneIcon } from '@/assets/icons/icons';

export const InboundCallTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'inbound_call_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Inbound call',

  hasInput: false,

  getIcon: (size: number) => (
    <PhoneIcon width={size} height={size} color='var(--light-blue)' />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const phoneNumber = data.inbound_call_trigger?.phone_number;
    return phoneNumber || 'No number configured';
  },

  CustomizationComponent: InboundCallTriggerCustomization,

  createDefaultNodeData: () =>
    buildNodeData('inbound_call_trigger', {
      phone_number: '',
    }),
};
